(function ($, dustars, theme) {
    theme.translate = {};
    theme.translate.group = [];
    theme.translate.default = 'tw';


    Dustars.Theme.TranslateGroup = function () {
        var self = this;
        this.$element = null;
        this.firstLanguage = theme.translate.default;
        this.defaultLanguage = theme.translate.default;
        this.currentLanguage = theme.translate.default;
        this.languages = [];
        this.blocks = [];
        this.isShown = false;

        this.showTranslate = function () {
            for (var i = 0; i < self.blocks.length; i++) {
                if (self.blocks[i] instanceof Dustars.Theme.TranslateBlock == false) {
                    continue;
                }

                if (self.blocks[i].language == self.currentLanguage) {
                    self.blocks[i].$element.addClass('show');
                    self.isShown = true;
                }
            }

            for (i = 0; i < self.blocks.length; i++) {
                if (self.blocks[i] instanceof Dustars.Theme.TranslateBlock == false) {
                    continue;
                }

                if (self.blocks[i].language == self.firstLanguage) {
                    self.blocks[i].$element.addClass('show');
                    self.isShown = true;
                }
            }
        };
    };
    
    Dustars.Theme.TranslateBlock = function () {
        var self = this;
        this.$element = null;
        this.language = theme.translate.default;
    };

    var initTranslateGroups = function () {
        $(".translate-group").each(function () {
            var $group = $(this);
            var group = new Dustars.Theme.TranslateGroup();
            group.$element = $group;

            var $translates = $group.find('[data-translate-language]');
            var firstLang = null;
            var languages = {};
            $translates.each(function () {
                var $translate = $(this);
                var lang = $translate.attr('data-translate-language');
                if (firstLang == null) {
                    firstLang = lang;
                }
                if ($.inArray(lang, group.languages) === -1) {
                    group.languages.push(lang);
                }

                var block = new Dustars.Theme.TranslateBlock();
                block.$element = $translate;
                block.language = lang;
                group.blocks.push(block);
            });

            group.firstLanguage = firstLang;
            theme.translate.group.push(group);
        });
    };

    var showTranslates = function () {
        $.each(theme.translate.group, function (index, value) {
            value.showTranslate();
        });
    };

    $(initTranslateGroups);
    $(showTranslates);

})(jQuery, dustars, dustars.theme);